import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 65,
	height: 11,
	viewBox: "0 0 65 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_2",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M3.48214 1.80952H0.696429C0.325 1.80952 0 1.47619 0 1.09524C0 0.714284 0.325 0.380951 0.696429 0.380951H3.48214C3.85357 0.380951 4.17857 0.714284 4.17857 1.09524C4.17857 1.47619 3.85357 1.80952 3.48214 1.80952Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M3.48214 7.52382H0.696429C0.325 7.52382 0 7.19048 0 6.80953C0 6.42858 0.325 6.09525 0.696429 6.09525H3.48214C3.85357 6.09525 4.17857 6.42858 4.17857 6.80953C4.17857 7.19048 3.85357 7.52382 3.48214 7.52382Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M3.48214 10.381H0.696429C0.325 10.381 0 10.0476 0 9.66668C0 9.28573 0.325 8.95239 0.696429 8.95239H3.48214C3.85357 8.95239 4.17857 9.28573 4.17857 9.66668C4.17857 10.0476 3.85357 10.381 3.48214 10.381Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M9.05357 4.66667H6.26785C5.89643 4.66667 5.57143 4.33334 5.57143 3.95238C5.57143 3.57143 5.89643 3.2381 6.26785 3.2381H9.05357C9.425 3.2381 9.75 3.57143 9.75 3.95238C9.75 4.33334 9.425 4.66667 9.05357 4.66667Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M9.05357 7.52382H6.26785C5.89643 7.52382 5.57143 7.19048 5.57143 6.80953C5.57143 6.42858 5.89643 6.09525 6.26785 6.09525H9.05357C9.425 6.09525 9.75 6.42858 9.75 6.80953C9.75 7.19048 9.425 7.52382 9.05357 7.52382Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M14.625 1.80952H11.8393C11.4679 1.80952 11.1429 1.47619 11.1429 1.09524C11.1429 0.714284 11.4679 0.380951 11.8393 0.380951H14.625C14.9964 0.380951 15.3214 0.714284 15.3214 1.09524C15.3214 1.47619 14.9964 1.80952 14.625 1.80952Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					d: "M14.625 4.66667H11.8393C11.4679 4.66667 11.1429 4.33334 11.1429 3.95238C11.1429 3.57143 11.4679 3.2381 11.8393 3.2381H14.625C14.9964 3.2381 15.3214 3.57143 15.3214 3.95238C15.3214 4.33334 14.9964 4.66667 14.625 4.66667Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_8",
					d: "M14.625 10.381H11.8393C11.4679 10.381 11.1429 10.0476 11.1429 9.66668C11.1429 9.28573 11.4679 8.95239 11.8393 8.95239H14.625C14.9964 8.95239 15.3214 9.28573 15.3214 9.66668C15.3214 10.0476 14.9964 10.381 14.625 10.381Z",
					fill: "black"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_9",
					d: "M21.2643 6.61905C21.2643 8.14286 22.1 8.95238 23.075 8.95238C23.9571 8.95238 24.9321 8.19047 24.9321 6.61905C24.9321 5.04762 24.0036 4.33333 23.1214 4.33333C22.1464 4.33333 21.2643 5.04762 21.2643 6.61905ZM21.2643 0.380951V4.09524C21.6821 3.42857 22.425 2.7619 23.6786 2.7619C25.0714 2.7619 26.7429 3.95238 26.7429 6.57143C26.7429 9.28571 25.1643 10.619 23.5393 10.619C22.6107 10.619 21.8214 10.1905 21.3107 9.33333V10.381H19.5V0.380951H21.2643Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_10",
					d: "M29.3893 6.66668C29.3893 8.2381 30.3179 8.95239 31.2 8.95239C32.175 8.95239 33.0107 8.28572 33.0107 6.66668C33.0107 5.09525 32.175 4.33334 31.2 4.33334C30.3643 4.33334 29.3893 5.04763 29.3893 6.66668ZM27.625 6.57144C27.625 4.00001 29.25 2.71429 30.875 2.71429C31.7571 2.71429 32.5 3.04763 33.0571 3.85715V2.90477H34.8214V10.381H33.0571V9.33334C32.5464 10.0476 31.8036 10.5714 30.6429 10.5714C29.25 10.5714 27.625 9.33334 27.625 6.57144Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_11",
					d: "M38.3036 6.14285V10.3809H36.5393V2.95238H38.3036V4.04762C38.8143 3.09524 39.7429 2.7619 40.5321 2.7619C41.7857 2.7619 42.9929 3.42857 42.9929 5.42857V10.3809H41.2286V6.09524C41.2286 4.85714 40.625 4.38095 39.8357 4.38095C38.9536 4.42857 38.3036 4.95238 38.3036 6.14285Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_12",
					d: "M44.6643 0.380951V10.381H46.4286V8.57143L47.4036 7.33333L49.4 10.381H51.35L48.4714 6.04762L50.9786 2.95238H48.9821L46.4286 6.38095V0.380951H44.6643Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_13",
					d: "M54.8786 0.714294H53.0679V10.381H54.8786V0.714294Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_14",
					d: "M60.125 0.714294H56.6893V10.381H60.125C62.6786 10.381 64.8143 8.80953 64.8143 5.52382C64.8143 2.28572 62.6786 0.714294 60.125 0.714294ZM60.125 8.66668H58.5V2.42858H60.125C61.6107 2.42858 62.8643 3.42858 62.8643 5.57144C62.8643 7.66668 61.6107 8.66668 60.125 8.66668Z",
					fill: "black"
				})
			]
		})]
	})
});
export default SvgBankid;
